export const STATUS_TYPES = {
    REQUESTED: {
        key: 'requested',
        label: 'Solicitado' 
    },
    CONFIRMED: {
        key: 'confirmed',
        label: 'Confirmado' 
    },
    PREPARING: {
        key: 'preparing',
        label: 'Em produção' 
    },
    READY_FOR_PICKUP: {
        key: 'ready_for_pickup',
        label: 'Pronto para retirada' 
    },
    PICKED_UP: {
        key: 'picked_up',
        label: 'Retirado' 
    },
    COMPLETED: {
        key: 'completed',
        label: 'Concluído' 
    },
    CANCELLED: {
        key: 'cancelled',
        label: 'Cancelado' 
    },
    REFUNDED: {
        key: 'refunded',
        label: 'Estornado' 
    },
}

export const STATUS_KEY_TO_TYPE = {
    [STATUS_TYPES.REQUESTED.key]: {
        key: 'requested',
        label: 'Solicitado' 
    },
    [STATUS_TYPES.CONFIRMED.key]: {
        key: 'confirmed',
        label: 'Confirmado' 
    },
    [STATUS_TYPES.PREPARING.key]: {
        key: 'preparing',
        label: 'Em produção' 
    },
    [STATUS_TYPES.READY_FOR_PICKUP.key]: {
        key: 'ready_for_pickup',
        label: 'Pronto para retirada' 
    },
    [STATUS_TYPES.PICKED_UP.key]: {
        key: 'picked_up',
        label: 'Retirado' 
    },
    [STATUS_TYPES.COMPLETED.key]: {
        key: 'completed',
        label: 'Concluído' 
    },
    [STATUS_TYPES.CANCELLED.key]: {
        key: 'cancelled',
        label: 'Cancelado' 
    },
    [STATUS_TYPES.REFUNDED.key]: {
        key: 'refunded',
        label: 'Estornado' 
    },
}

export const STATUS_TRANSITIONS = {
    [STATUS_TYPES.REQUESTED.key]: [STATUS_TYPES.PREPARING.key],
    [STATUS_TYPES.PREPARING.key]: [STATUS_TYPES.READY_FOR_PICKUP.key],
    [STATUS_TYPES.READY_FOR_PICKUP.key]: [STATUS_TYPES.PICKED_UP.key],
    [STATUS_TYPES.PICKED_UP.key]: [STATUS_TYPES.COMPLETED.key],
};